<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播马甲信息管理</h1>
    <div :gutter="20" class="user-options">
      主播rid:
      <el-input
        type="number"
        v-model="rid"
        :disabled="true"
        style="width: 160px"
        placeholder="请输入内容"
      ></el-input>
      展示类型:
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="showType"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in showTypes"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      展示场景:
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="showScene"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in showSceness"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      数据来源:
      <el-select
        style="width: 160px"
        class="header-item"
        v-model="fromType"
        placeholder=""
      >
        <el-option
          v-for="(item, itemIndex) in fromTypes"
          :key="itemIndex"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>

      <el-button type="warning" @click="getDayChatDetai()" :loading="login1">
        查询
      </el-button>
      <el-button type="success" @click="cre">
        创建
      </el-button>
    </div>
    <!-- 创建弹窗 -->
    <el-drawer
      :title="msg ? '修改' : '创建'"
      size="35%"
      style="z-index:2999"
      :visible.sync="drawer"
      :modal="false"
      :direction="direction"
      :before-close="handleClose"
    >
      <div class="add">
        <el-row>
          <el-col class="el-cols">
            <span>主播id:</span>
            <el-input
              :disabled="msg"
              type="number"
              v-model="list.rid"
              style="width: 160px"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-row>
        <el-row v-if="showType_s">
          <el-col class="el-cols">
            <span>展示类型:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="list.showType"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in showTypess"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>展示场景:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="list.showScene"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in showSceness"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>数据类型:</span>
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="list.fromType"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in fromTypes"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>渠道:</span>
            <el-select style="width: 160px" v-model="list.channel" placeholder>
              <el-option
                v-for="(item, itemIndex) in channels"
                v-bind:key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>上传/填写链接</span>
            <el-select
              style="width: 160px"
              class="header-item"
              v-model="tyoefr"
              @change="spleis"
              placeholder=""
            >
              <el-option
                v-for="(item, itemIndex) in tyoefrs"
                :key="itemIndex"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row v-show="tyoefr == 1">
          <el-col class="el-cols">
            <span>内容:</span>
            <el-upload
              class="upload-demo wid"
              :limit="1"
              action=""
              ref="upload"
              :http-request="submitUpload"
            >
              <el-button type="primary">图片</el-button>
            </el-upload>
          </el-col>
        </el-row>
        <el-row v-show="tyoefr == 2">
          <el-col class="el-cols">
            <span>内容:</span>
            <el-input
              v-model="list.content"
              style="width: 260px"
              type="textarea"
              :rows="2"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="el-cols">
            <span>排序权:</span>
            <el-input
              v-model="list.orderId"
              style="width: 160px"
              type="number"
              placeholder="请输入"
            ></el-input>
          </el-col>
        </el-row>

        <el-row class="buttom">
          <el-button type="primary" v-if="!msg" @click="establish()"
            >确定</el-button
          >
          <el-button type="primary" v-if="msg" @click="getDayChatDetais()"
            >确定</el-button
          >
        </el-row>
      </div>
    </el-drawer>

    <!-- 表格 -->
    <el-row class="user-options">
      <el-table
        height="60vh"
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        border
      >
        <el-table-column prop="rid" label="主播rid" align="center">
          <template slot-scope="scope">
            <div @click="getDayChatDetai(scope.row.rid)">
              {{ scope.row.rid }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="nickName" label="昵称" align="center">
        </el-table-column>
        <el-table-column prop="countryCode" label="国家码" align="center">
        </el-table-column>
        <el-table-column prop="translateId" label="语言" align="center">
        </el-table-column>
        <el-table-column
          width="150px"
          align="center"
          prop="authHead"
          label="头像"
          sortable
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.authHead"
              fit="scale-down"
              :preview-src-list="[scope.row.authHead]"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="showType" label="展示类型" align="center">
          <template slot-scope="scope">
            {{
              scope.row.showType == '1'
                ? '头像'
                : scope.row.showType == '2'
                ? '主播banner'
                : '名字'
            }}
          </template>
        </el-table-column>
        <el-table-column prop="fromType" label="数据来源" align="center">
          <template slot-scope="scope">
            {{
              scope.row.fromType == 1
                ? '手动导入'
                : scope.row.fromType == 2
                ? '运营平台操作写入'
                : '主播上传AB面素材审核'
            }}
          </template>
        </el-table-column>
        <el-table-column prop="showScene" label="展示场景" align="center">
        </el-table-column>
        <el-table-column prop="channel" label="渠道" align="center">
        </el-table-column>
        <el-table-column
          width="150px"
          prop="content"
          label="内容"
          align="center"
        >
          <template slot-scope="scope">
            <el-image
              style="width:100px"
              v-if="scope.row.showType != 3"
              :src="scope.row.content"
              :preview-src-list="[scope.row.content]"
            ></el-image>
            <p v-if="scope.row.showType == 3">{{ scope.row.content }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="orderId" label="排序权重" align="center">
        </el-table-column>
        <el-table-column prop="ctime" label="创建时间" align="center">
          <template slot-scope="scope">
            {{ format_(scope.row.ctime) }}
          </template>
        </el-table-column>
        <el-table-column prop="mtime" label="修改时间" align="center">
          <template slot-scope="scope">
            {{ format_(scope.row.mtime) }}
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" align="center">
        </el-table-column>
        <el-table-column label="操作" width="380px" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="edit(scope.row)">编辑</el-button>
            <el-button type="primary" @click="dele(scope.row)">删除</el-button>
            <el-button
              v-if="scope.row.showType != 1"
              type="primary"
              @click="head(scope.row)"
              >设为头像</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!-- 分页 -->
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
        class="pagination"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      fromType: 2,
      fromTypes: [
        {
          label: '手动导入',
          value: 1
        },
        {
          label: '运营平台操作写入',
          value: 2
        },
        {
          label: '主播上传AB面素材审核',
          value: 3
        }
      ],
      rid: '', //礼物名称
      showType: 0, //礼物类型
      showTypes: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '头像',
          value: 1
        },
        {
          label: '主播banner',
          value: 2
        },
        {
          label: '名字',
          value: 3
        }
      ],
      showTypess: [
        {
          label: '头像',
          value: 1
        },
        {
          label: '主播banner',
          value: 2
        },
        {
          label: '名字',
          value: 3
        }
      ],
      changeShowTypes: [
        {
          label: '头像',
          value: 1
        },
        {
          label: '主播banner',
          value: 2
        }
      ],
      showScene: '', //礼物场景
      showScenes: [
        {
          label: '全部',
          value: ''
        },
        {
          label: 'A',
          value: 'A'
        },
        {
          label: 'B',
          value: 'B'
        }
      ],
      showSceness: [
        {
          label: 'A',
          value: 'A'
        },
        {
          label: 'B',
          value: 'B'
        }
      ],
      changeShowType: 1,
      list: {
        rid: '', //主播id
        showType: 1, //展示类型
        showScene: 'A', //展示场景
        channel: 'appstore_camchat', //渠道
        content: '', //内容
        orderId: '', //排序权重
        operator: this.$store.getters.username,
        fromType: 2
      },
      tyoefr: 1,
      tyoefrs: [
        {
          label: '上传',
          value: 1
        },
        {
          label: '填写链接',
          value: 2
        }
      ],
      file: '',
      channels: this.$store.state.channels,
      row_list: {},
      msg: false,
      drawer: false,
      direction: 'rtl',
      // 加载
      login1: false,
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],
      drawer_: false,
      showType_s: false
    }
  },
  created () {
    // this.getDayChatDetai()
  },
  methods: {
    spleis (ele) {
      if (ele == 1) {
        this.$refs.upload.clearFiles()
      }
    },
    // 删除
    dele (row) {
      this.$confirm('是否删除？').then(async () => {
        let url =
          this.$store.getters.path.hostmgr_del +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token
        const { data: res } = await this.$axios.get(url, {
          params: {
            id: row.id
          }
        })
        if (res.code !== 0) return this.$message.error(res.msg)
        this.$message.success(res.msg)
        this.getDayChatDetai()
      })
    },
    // 静态
    submitUpload (param) {
      let file = param.file
      this.file = file
      this.submitUpload_(file)
    },
    async submitUpload_ (file) {
      let data = new FormData()
      data.append('file', file)
      data.append('cover', 0)
      data.append('dir', 'actor/vest/bag/' + this.list.rid)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        data
      )
      this.list.content = res.data
    },
    edit (row) {
      this.msg = true
      this.drawer = true
      this.showType_s = false
      this.list = {
        rid: row.rid,
        id: row.id,
        uid: row.uid,
        showType: row.showType,
        showScene: row.showScene,
        channel: 'appstore_camchat',
        content: row.content,
        fromType: row.fromType,
        orderId: row.orderId
      }
      this.list.operator = this.$store.getters.username
    },
    handleUploadSuccess (res) {
      this.list.content = res.data
    },
    gifttupe (row) {
      let date = {
        0: '消息礼物',
        1: '通话礼物',
        2: '假视频礼物',
        3: 'live'
      }
      return date[row]
    },

    // 查询列表
    async getDayChatDetai (rids) {
      this.login1 = true
      let data = {
        username: this.$store.getters.username,
        token: this.$store.getters.token,
        showType: this.showType,
        showScene: this.showScene,
        fromType: this.fromType,
        page: this.page,
        rid: this.rid
      }
      if (rids) {
        data.rid = rids
        data.page = 1
      }

      let url =
        this.$store.getters.path.hostmgr_list +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token

      const { data: res } = await this.$axios.post(url, data)
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.dayChatDetailData = res.data.data
      this.total = res.data.total
    },
    head (row) {
      this.$confirm('确定设置为头像？')
        .then(() => {
          this.getDayChatDetais(row)
        })
        .catch(() => {})
    },
    format_ (data) {
      let date = new Date(data * 1000) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      let D =
        (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 修改
    async getDayChatDetais (row) {
      this.login1 = true
      let data = {
        id: this.list.id,
        uid: this.list.uid,
        showType: this.list.showType,
        showScene: this.list.showScene,
        channel: this.list.channel,
        content: this.list.content,
        fromType: this.list.fromType,
        orderId: this.list.orderId,
        operator: this.list.operator,
        changeShowType: 0
      }
      if (row) {
        data = {
          id: row.id,
          uid: row.uid,
          showType: 1,
          changeShowType: 1,
          showScene: row.showScene,
          channel: row.channel,
          content: row.content,
          orderId: row.orderId,
          fromType: row.fromType,
          operator: this.list.operator
        }
      }
      let url =
        this.$store.getters.path.hostmgr_update +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token

      const { data: res } = await this.$axios.post(url, data)
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      this.handleClose()
      this.getDayChatDetai()
    },
    // 创建
    async establish () {
      let url =
        this.$store.getters.path.hostmgr_create +
        '?username=' +
        this.$store.getters.username +
        '&token=' +
        this.$store.getters.token
      let data = this.list
      const { data: res } = await this.$axios.post(url, data)
      if (res.code != 0) return this.$message.error(res.msg)
      this.$message.success(res.msg)
      this.handleClose()
      this.getDayChatDetai()
    },
    cre () {
      this.drawer = true
      this.msg = false
      this.showType_s = true
    },
    // 分页
    handleCurrentChange () {
      this.getDayChatDetai()
    },
    handleClose () {
      this.drawer = false
      this.tyoefr = 1
      this.list = {
        rid: '', //主播id
        showType: 1, //展示类型
        showScene: 'A', //展示场景
        channel: 'appstore_camchat', //渠道
        content: '', //内容
        orderId: '', //排序权重
        fromType: 2, //排序权重
        operator: this.$store.getters.username
      }
    },
    handleClose_ () {
      this.drawer_ = false
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }
  }

  .display-type {
    margin-top: 20px;
    .line {
      width: 1440px;
      height: 700px;
    }
  }
}
.add {
  .el-row {
    padding: 0 30px;
    span {
      display: block;
      margin: 0 0 10px;
    }
    .el-input {
      width: 150px;
    }
    > .el-cols {
      display: flex;
      align-items: center;
      > span {
        width: 140px;
      }
    }
  }
  .buttom {
    display: flex;
    justify-content: flex-end;
    margin: 0 100px;
  }
}

.row {
  font-size: 14px;
  > div {
    display: flex;
    padding: 0 30px;
    align-content: center;
    flex-wrap: wrap;
    margin: 0 0 20px;
    > div {
      margin: -5px 30px 0;
      display: flex;
      align-items: center;
      > span {
        width: 100px;
      }
    }
  }
}
</style>
